import { useSelector } from "react-redux";
import { RootState } from "../store";
import {
  useGetUserWorkItemsQuery,
} from "../store/services/workItemService";
import { UserWorkItemsParams } from "../store/types/work.types";

/**
 * Fetches active work items for the currently selected user in Redux.
 * Returns the same result as useGetUserWorkItemsQuery, but automatically uses the selected user.
 */
export function useActiveUserWorkItems(
  params?: UserWorkItemsParams,
  options?: { skip?: boolean }
) {
  const selectedUserId = useSelector(
    (state: RootState) => state.user.selectedUserId
  );
  return useGetUserWorkItemsQuery(
    {
      userId: selectedUserId ?? undefined,
      ...params,
    },
    options
  );
}